import React, {FC, memo, useCallback, useEffect, useLayoutEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {AppDispatch, IRootState} from "../../store/configureStore";
import {Dropdown, DropdownButton, ToggleButton} from "react-bootstrap";
import {PageFilesAction, PageFilesContainer, PageFilesContent} from "./PageFilesStyle";
import Card from "../../component/Card/CardImg";

import {ArrowsMove, JournalCheck, Trash3, Upload} from "react-bootstrap-icons";
import {actions as actionsFiles, IFile} from "../../store/sliceFiles";
import {actions as actionsToken} from "../../store/sliceToken";
import {useParams} from "react-router-dom";
import {fetchUploadFiles} from "../../fetch/FileRequest";
import CardBack from "../../component/Card/CardBack";
import CardFolder from "../../component/Card/CardFolder";
import CardDefault from "../../component/Card/CardDefault";
import PageNotFound from "../notFound/PageNotFound";
import {fetchPublicFiles, fetchPublicUploadFiles} from "../../fetch/PublicFileRequest";
import {Container, HeaderContainer} from "../header/HeaderStyle";
import MainLabel from "../../component/mainLabel/MainLabel";


const PublicPageFiles: FC = (props) => {
    const dispatch = useDispatch<AppDispatch>();
    const {publicId, id} = useParams()

    const [checked, setChecked] = useState(false)
    // const [delEnable, setDelEnable] = useState(false)

    const [notFound, setNotFound] = useState(false)


    const {fileList, checkedList} = useSelector((state: IRootState) => state.files)

    useLayoutEffect(() => {
        dispatch(actionsToken.clear())
        if (publicId == null) {
            setNotFound(true);
        } else if (id == null) {
            fetchPublicFiles(publicId).then(resp => {
                if (resp.status != null &&  resp.status > 300) {
                    setNotFound(true);
                }
            })
        } else if (isNaN(Number(id))) {
            setNotFound(true);
        } else {
            fetchPublicFiles(publicId, Number(id)).then(resp => {
                if (resp.status != null &&  resp.status > 300) {
                    setNotFound(true);
                }
            })
        }
    }, [id, publicId])

    useEffect(() => {
        if (!checkedList?.length) {
            setChecked(false)
        }
    }, [checkedList])

    const fileListRender = useCallback(() => {

        if (fileList?.length == 0) {
            return <></>
        }

        const listFolder = fileList.filter((file: IFile) => file.folder)
            .map((file: IFile) => <CardFolder checkMode={checked} file={file} publicPath={publicId}/>)


        const listFiles = fileList.filter((file: IFile) => !file.folder).map((file: IFile) => {
            if (['png', 'jpg', 'jpeg', 'gif'].includes(file?.type?.toLowerCase())) {
                return (<Card checkMode={checked} file={file} publicPath={publicId}/>)
            }
            return (<CardDefault checkMode={checked} file={file} publicPath={publicId}/>)
        })
        return [...listFolder, ...listFiles]
    }, [fileList, checked, publicId])


    const checkboxChange = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.currentTarget.checked) {
            setChecked(true)
        } else {
            setChecked(false)
            dispatch(actionsFiles.clearChecked())
        }
    }, [])

    const uploadFiles = useCallback((event: React.MouseEvent<HTMLButtonElement>) => {
        if (publicId?.length != null) {
            fetchPublicUploadFiles(publicId, checkedList).then(resp => {
                if (resp.status === 200) {
                    dispatch(actionsFiles.clearChecked())
                    setChecked(false)
                }
            })
        } else {
            fetchUploadFiles(checkedList).then(resp => {
                if (resp.status === 200) {
                    dispatch(actionsFiles.clearChecked())
                    setChecked(false)
                }
            })
        }
    }, [checkedList, publicId])



    if (notFound) {
        return (
            <PageNotFound/>
        )
    }

    return (
            <PageFilesContainer as={"section"}>
                <PageFilesAction style={{top: 0}}>
                    <div style={{marginRight: "auto"}}>
                        <DropdownButton variant={"outline-secondary"} disabled={!(checked && checkedList.length > 0)} title="Действия">
                            <Dropdown.Item as="button" disabled style={{marginBottom: "10px"}}>
                                <Trash3 style={{marginRight: "5px"}}/>
                                Удалить
                            </Dropdown.Item>
                            <Dropdown.Item as="button" onClick={uploadFiles} style={{marginBottom: "10px"}}>
                                <Upload style={{marginRight: "5px"}}/>
                                Выгрузить
                            </Dropdown.Item>
                            <Dropdown.Item as="button" disabled style={{marginBottom: "0px"}}>
                                <ArrowsMove style={{marginRight: "5px"}}/>
                                Переместить
                            </Dropdown.Item>
                        </DropdownButton>
                    </div>

                    <ToggleButton
                        id="toggle-check"
                        type="checkbox"
                        variant="outline-success"
                        checked={checked}
                        value="1"
                        onChange={checkboxChange}
                    >
                        <JournalCheck style={{marginRight: "5px"}}/>
                        <span>Выбор</span>
                    </ToggleButton>
                </PageFilesAction>
                <PageFilesContent>
                    {id !== undefined &&
                        <CardBack parentId={fileList.length > 0 ? fileList[0]?.parentId : undefined}/>}
                    {fileListRender()}
                </PageFilesContent>
            </PageFilesContainer>
    );
}
export default memo(PublicPageFiles);
